/**
 * Based on the premise that non-custom rates have an id.
 * 
 * @param {{ id: any }} rate 
 * @returns {boolean | undefined} undefined if rate is not passed
 */
function isProviderRate(rate) {
    if (!rate) {
        return;
    }

    return !!rate.id;
}

export default isProviderRate;